<template>
  <RevIllustration
    alt=""
    class="size-60 max-w-60 align-top md:size-[110px] md:min-w-[110px]"
    :height="60"
    :src
    :width="60"
  />
</template>

<script lang="ts" setup>
import { RevIllustration } from '@ds/components/Illustration'

defineProps<{
  src: string
}>()
</script>
